<template>
  <div id="pricepreview">
    <h2 v-if="price">
      Der mögliche Ankaufspreis für deinen <b>{{name}}</b>
    </h2>

    <h2 v-if="!price">
      Leider konnten wir keinen Ankaufpreis für deinen <b>{{name}}</b> ermitteln
    </h2>

    <div v-if="price" class="pricepreview-price">
      <span>{{price}}</span>
      <span>&euro;</span>
    </div>

    <div v-if="price" class="pricepreview-info">Dein möglicher Ankaufspreis</div>
  </div>
</template>

<script>
  export default {
    props: ['name'],
    data: function() {
      return {}
    },
    computed: {
      price: function() {
        let price = (this.$store.state.lead || {}).valuated_price_low;

        if(price) {
          return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        } else {
          return null;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

#pricepreview {
    padding: 0 18px 55px;

    h2 {
      font-size: 24px;
      line-height: 30px;
      font-weight: bold;
      color: $dark-gray-variant;
      margin-bottom: 27px;

      b {
        display: block;
        color: $green-variation;
      }
    }

  .pricepreview-price {
    color: $dark-gray-variant;
    font-size: 38px;
    line-height: 32px;
    font-weight: bold;
    display: inline-block;
  }

  .pricepreview-info {
    color: $dark-gray-variant;
    font-size: 16px;
    line-height: 22px;
  }
}

@media (max-width: 500px) {
  #pricepreview h2 {
      font-size: 25px;
  }

  .pricepreview-price {
      font-size: 42px;
      margin-bottom: 6px;
  }
}

@media print {
  #pricepreview {
    padding: 0;
    text-align: left;

    h2 {
      font-size: 20px;
      margin-bottom: 0;
      & > b { color: $dark-gray-variant; }
    }
  }

  .pricepreview-price {
    padding-top: 50px;
    padding-bottom: 15px;
  }

  .pricepreview-info {
    padding-bottom: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/summary/SummaryPricepreview.vue